import { otherClient } from "../client/other-client";

export const getAuditTrail = async (
  page,
  limit,
  startDate,
  endDate,
  search
) => {
  try {
    const params = new URLSearchParams();
    if (page != null) params.append("page", page);
    if (limit != null) params.append("limit", limit);
    if (startDate) params.append("startDate", startDate);
    if (endDate) params.append("endDate", endDate);
    if (search) params.append("q", search);
    const response = await otherClient.get(`/audit?${params.toString()}`);
    return response.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const getUserAuditTrail = async (
  page,
  limit,
  startDate,
  endDate,
  userId,
  search
) => {
  try {
    const params = new URLSearchParams();
    if (page != null) params.append("page", page);
    if (limit != null) params.append("limit", limit);
    if (startDate) params.append("startDate", startDate);
    if (endDate) params.append("endDate", endDate);
    if (userId) params.append("userId", userId);
    if (search) params.append("q", search);
    const response = await otherClient.get(`/audit?${params.toString()}`);
    return response.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const downloadAuditTrail = async (
  page,
  limit,
  startDate,
  endDate,
  userId,
  exportType
) => {
  try {
    const params = new URLSearchParams();
    if (page != null) params.append("page", page);
    if (limit != null) params.append("limit", limit);
    if (startDate) params.append("startDate", startDate);
    if (endDate) params.append("endDate", endDate);
    if (userId) params.append("userId", userId);
    if (exportType) params.append("export", exportType);
    const response = await otherClient.get(`/audit?${params.toString()}`);
    return response.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};

export const downloadSelectedAuditTrail = async (selectedTrails) => {
  try {
    const response = await otherClient.post(`/audit/export-selected`, {
      ids: selectedTrails,
      format: "csv",
    });
    return response.data;
  } catch (error) {
    throw error?.response?.data || error;
  }
};
